import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../../data/kit';
import { Highlight, SectionHeading } from '../ui/SectionHeading';
export function ProblemsSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-130" data-mp="1icfgz02ld9ov">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-131" data-mp="1id79u34t0tbg">
        <SectionHeading title={<>
              If you work in speech therapy, you probably know{' '}
              <Highlight data-id="element-133" data-mp="2a3btu0onjec5">at least one of these.</Highlight>
            </>} data-id="element-132" data-mp="1dew3419t2yxg" />
        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-134" data-mp="2631n2lt1cjw8">
          {problems.map(problem => <li key={problem} className="flex items-start gap-4 rounded-2xl border border-line bg-cream p-6" data-id="element-135" data-mp="219ypm2l50qar">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-teal text-white" data-id="element-136" data-mp="1wavxtju64gkq">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-137" data-mp="2ttx9f3eq2mw3" />
              </span>
              <p className="pt-1 text-base font-medium leading-snug text-petrol" data-id="element-138" data-mp="2ozb0d6w456f6">{problem}</p>
            </li>)}
        </ul>
        <p className="mt-12 text-center font-display text-[28px] font-bold uppercase leading-tight text-petrol sm:text-[34px]" data-id="element-139" data-mp="17577rhebyjjz">
          How many more sessions will start with <Highlight data-id="element-140" data-mp="tbzfdnifdk18">a blank page?</Highlight>
        </p>
      </div>
    </section>;
}